import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import commonConstant from '../../common/_commonConstant';
import { getCookieToken, getCookieUserId } from '../../common/_commonFunction';
import { Loading } from '../../components';
import { history, passParamsToPath, isSuperAdmin, isAccounting, isCashier, isAdmin, isOperation } from '../../helpers';
import { fetchGetProfile } from '../../actions';

class CheckRedirect extends Component {
  UNSAFE_componentWillMount() {
    if (!getCookieToken() || !getCookieUserId()) {
      return history.push(commonConstant.pathLogout);
    }
    this.props.dispatch(fetchGetProfile());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getProfile, match } = this.props;

    if (nextProps.getProfile && nextProps.getProfile !== getProfile) {
      if (nextProps.getProfile.status === 200 && isSuperAdmin(nextProps.getProfile.data)) {
        return history.push(commonConstant.pathSelectBuilding);
      } else if (nextProps.getProfile.status === 200 && isAccounting(nextProps.getProfile.data)) {
        return history.push(passParamsToPath(commonConstant.pathAccountingReport, nextProps.getProfile.data.building));
      } else if (nextProps.getProfile.status === 200 && isCashier(nextProps.getProfile.data)) {
        return history.push(passParamsToPath(commonConstant.pathSearchVehicleLicensePlate, nextProps.getProfile.data.building));
      } else if (nextProps.getProfile.status === 200 && isOperation(nextProps.getProfile.data)) {
        return history.push(passParamsToPath(commonConstant.pathOperationReport, nextProps.getProfile.data.building));
      } else if (nextProps.getProfile.status === 200 && isAdmin(nextProps.getProfile.data)) {
        return history.push(passParamsToPath(commonConstant.pathUserManagement, nextProps.getProfile.data.building));
      }
      return history.push(commonConstant.pathLogout);
    } else if (nextProps.match.url !== match.url) {
      if (nextProps.match.path === commonConstant.pathAccountingReport) {
        if (isCashier(nextProps.getProfile.data)) {
          return history.push(passParamsToPath(commonConstant.pathSearchVehicleLicensePlate, nextProps.getProfile.data.building));
        } else if (isAdmin(nextProps.getProfile.data)) {
          return history.push(passParamsToPath(commonConstant.pathUserManagement, nextProps.getProfile.data.building));
        } else if (isOperation(nextProps.getProfile.data)) {
          return history.push(passParamsToPath(commonConstant.pathOperationReport, nextProps.getProfile.data.building));
        }
      }
    }
  }

  render() {
    return <Loading />;
  }
}

CheckRedirect.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'url': PropTypes.string,
    'path': PropTypes.string,
  }),
  'getProfile': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'building': PropTypes.shape({}),
    }),
  }),
};

const mapStateToProps = ({ getProfile }) => ({ getProfile });

export default connect(mapStateToProps)(CheckRedirect);
